module.exports = __webpack_public_path__ + "static/img/dragon.8cb5f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/featureLogo/dragon.png
// module id = irfe
// module chunks = 0